import Column from '@components/Column';
import Radio from '@components/Radio';
import styled from '@emotion/styled';
import useProjectId from '@hooks/useProjectId';
import { OrderType } from '@models/order';
import useCalculatedRequest from '@store/order/hooks/useCalculatedRequest';
import { orderActions } from '@store/order/orderSlice';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import SectionTitle from '../common/SectionTitle';

const TOKYO_PLATZ_ID = import.meta.env.VITE_TOKYO_PLATZ_ID;
const PAIKS_DABANG_ID = import.meta.env.VITE_PAIKS_DABANG_ID;
const TOKYO_PLATZ_HANZOMON_ID = '0rn8w979sjm5a';

function OrderTypeSelector() {
    const { orderType, shopId } = useCalculatedRequest();
    const dispatch = useDispatch();
    const { t } = useTranslation('order');
    const updateOrderType = (ot: OrderType) => {
        dispatch(orderActions.setOrderType(ot));
    };
    const projectId = useProjectId();
    const takeOutOnlyProjectIds = [TOKYO_PLATZ_ID, PAIKS_DABANG_ID];
    const takeoutOnlyExcludeShopIds = [TOKYO_PLATZ_HANZOMON_ID];

    const showInShop = !takeOutOnlyProjectIds.includes(projectId)
        || takeoutOnlyExcludeShopIds.includes(shopId);

    return (
        <Container fullWidth spacing={4}>
            <SectionTitle>{t('orderType.title')}</SectionTitle>
            <Column fullWidth>
                <Option>
                    <Radio value='TAKE_OUT' isSelected={orderType === 'TAKE_OUT'}
                        onChange={() => updateOrderType('TAKE_OUT')}>
                        {t('orderType.takeOut')}
                    </Radio>
                </Option>
                {/* TODO 매장별 주문 방법 설정 후 제거 */}
                {showInShop && (
                    <Option>
                        <Radio value='IN_SHOP' isSelected={orderType === 'IN_SHOP'}
                            onChange={() => updateOrderType('IN_SHOP')}>
                            {t('orderType.inShop')}
                        </Radio>
                    </Option>
                )}
            </Column>
        </Container>
    );
}

const Container = styled(Column)`
    padding: var(--spacing-4);
`;

const Option = styled.div`
    padding: var(--spacing-2) 0;
    width: 100%;
`;

export default OrderTypeSelector;
